import React, {Component} from "react";
import {withTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {Spinner} from "../Spinner";
import {SubmitButton} from "../buttons/SubmitButton";
import {BUSINESS_TYPE_OPTIONS} from "./ClientProfileForm";

// "Modelo de conversión" (ex "Tipo de negocio", card 3d8JWLj1) en Configuración (reemplaza el tab
// Perfil, 2026-07-06): es el único campo
// del perfil que sobrevive — input clave para la IA y el generador de reportes. Industria/KPI/
// notas los reemplaza la Memoria del Cliente; acá se preservan al guardar (el PUT del profile
// pisa todos los campos) pero no se editan.
class ClientBusinessContextClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            saving: false,
            business_type: '',
            rest: {industry: null, primary_kpi: null, notes: null},
        };
    }

    componentDidMount() {
        new APIClient(this._url()).call('GET').then((data) => {
            if (data && data.status === 'OK') {
                this.setState({
                    loading: false,
                    business_type: data.data.business_type || '',
                    rest: {
                        industry: data.data.industry || null,
                        primary_kpi: data.data.primary_kpi || null,
                        notes: data.data.notes || null,
                    },
                });
            } else {
                this.setState({loading: false});
            }
        });
    }

    _url() {
        return API_URL + 'client/' + this.props.clientId + '/profile';
    }

    handleSubmit = () => {
        const {t} = this.props;
        this.setState({saving: true});
        new APIClient(this._url()).call('PUT', {
            business_type: this.state.business_type || null,
            ...this.state.rest,
        }).then((data) => {
            this.setState({saving: false});
            if (data && data.status === 'OK') {
                toast.success(t('client_profile.save_success'));
            } else {
                toast.error((data && data.error_message) || t('client_profile.save_error'));
            }
        });
    };

    render() {
        const {t} = this.props;
        return (
            <div className="section-body-item -slim">
                <div className="box">
                    <header className="box-header">
                        <h2 className="box-title">{t('client_config.business_context_title')}</h2>
                    </header>
                    {this.state.loading ? (
                        <div className="box-loader"><Spinner color="positive"/></div>
                    ) : (
                        <>
                            <div className="form-row">
                                <label>{t('client_profile.business_type')}:</label>
                                <select name="business_type" value={this.state.business_type}
                                        onChange={(e) => this.setState({business_type: e.target.value})}>
                                    <option value="">{t('client_profile.select_option')}</option>
                                    {BUSINESS_TYPE_OPTIONS.map((opt) => (
                                        <option key={opt.value} value={opt.value}>{t(opt.labelKey)}</option>
                                    ))}
                                </select>
                                <p className="form-field-hint">{t('client_config.business_context_hint')}</p>
                            </div>
                            <div className="submit-row">
                                {this.state.saving
                                    ? <Spinner color="positive small"/>
                                    : <SubmitButton onClick={this.handleSubmit} value={t('client_profile.save')}/>}
                            </div>
                        </>
                    )}
                </div>
            </div>
        );
    }
}

export const ClientBusinessContext = withTranslation()(ClientBusinessContextClass);
